<fuse-navigation layout="horizontal" role="navigation"></fuse-navigation>